import Icon from '../components/Icon.vue'

Icon.register({"store-alt":{"width":640,"height":512,"paths":[{"d":"M320 384H128V224H64V480C64 497.7 78.3 512 96 512H352C369.7 512 384 497.7 384 480V224H320V384zM634.6 142.2L549.3 14.2C543.3 5.3 533.3 0 522.6 0H117.4C106.7 0 96.7 5.3 90.8 14.2L5.5 142.2C-8.7 163.5 6.5 192 32.1 192H608C633.5 192 648.7 163.5 634.6 142.2zM512 496C512 504.8 519.2 512 528 512H560C568.8 512 576 504.8 576 496V224H512V496z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/store-alt.js
// module id = UtTt
// module chunks = 0